<div class="modal-header">
  <h5 class="modal-title"
      id="guestCheckinModalLabel">Checkin guest</h5>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <form (ngSubmit)="onSubmit()"
        [formGroup]="checkinForm">
    <h5>Reservation</h5>

    <div class="row">
      <div class="col-md-6">
        <label class="col-form-label"
               for="checkinDate">Checkin: </label>
        <input class="form-control"
               required
               id="checkinDate"
               formControlName="checkinDate"
               type="date" />
      </div>

      <div class="col-md-6">
        <label class="col-form-label"
               for="checkoutDate">Checkout: </label>
        <input class="form-control"
               required
               id="checkoutDate"
               formControlName="checkoutDate"
               type="date" />
      </div>
    </div>

    <div formGroupName="booker">
      <h5>Booker</h5>

      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label"
                 for="firstName">First name: </label>
          <input class="form-control"
                 required
                 id="firstName"
                 formControlName="firstName"
                 type="text" />
        </div>

        <div class="col-md-6">
          <label class="col-form-label"
                 for="lastName">Last name: </label>
          <input class="form-control"
                 required
                 id="lastName"
                 formControlName="lastName"
                 type="text" />
        </div>
      </div>

      <div>
        <label class="form-label"
               for="emailAddress">Email: </label>
        <input class="form-control"
               required
               id="emailAddress"
               formControlName="emailAddress"
               type="text" />
      </div>
    </div>

    <div formArrayname="guests"
         class="mb-3">
      <h5>Guests</h5>

      @for (guest of guests.controls; track guest; let i = $index) {
        <div [formGroup]="guest">
          <div class="col-md-5">
            <label class="col-form-label"
                   for="guestFirstName-{{ i }}">First name:</label>
            <input class="form-control"
                   id="guestFirstName-{{ i }}"
                   type="text"
                   formControlName="guestFirstName" />
          </div>
          <div class="col-md-5">
            <label class="col-form-label"
                   for="guestLastName-{{ i }}">Last name:</label>
            <input class="form-control"
                   id="guestLastName-{{ i }}"
                   type="text"
                   formControlName="guestLastName" />
          </div>
          <div class="col-md-2 align-self-end">
            <button type="button"
                    class="btn btn-outline-danger border-0 mb-3"
                    (click)="deleteGuest(i)">
              <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
            </button>
          </div>
        </div>
      }

      <button type="button"
              class="btn btn-primary"
              (click)="addGuest()">+ Add another guest</button>
    </div>

    <button type="button"
            class="btn btn-secondary"
            (click)="activeModal.close('Close click')">Close</button>
    <button type="submit"
            class="btn btn-primary"
            [disabled]="!checkinForm.valid">Checkin</button>
  </form>
</div>